import { render } from "./SettingsPracticePreferences.vue?vue&type=template&id=17c7a9a5"
import script from "./SettingsPracticePreferences.vue?vue&type=script&lang=js"
export * from "./SettingsPracticePreferences.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__